/* src/app/features/programas-permitidos-por-cestas/listagem/programas-permitidos-por-cestas-listagem.component.scss */
.table-responsive {
  margin-top: 40px;
}
.destacar-td td {
  font-weight: bold;
}
/*# sourceMappingURL=programas-permitidos-por-cestas-listagem.component.css.map */
